
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","fill":"none"}},[_c('path',{attrs:{"fill":"#fff","d":"M2.707 3.96a1 1 0 00-1.414 1.414L2.707 3.96zM8 10.667l-.707.707a1 1 0 001.414 0L8 10.667zm6.707-5.293a1 1 0 00-1.414-1.414l1.414 1.414zm-13.414 0l6 6L8.707 9.96l-6-6-1.414 1.414zm7.414 6l6-6-1.414-1.414-6 6 1.414 1.414z"}})])
      }
    
      }
    